// extracted by mini-css-extract-plugin
module.exports =  {"root":"kYKxTsUKSkAx94DeKrBw","icon":"m427L6TPH3CKUhuBpOGE","disabled":"bNa3CHTJfDxbO7KviiAa"};